import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import TransactionStatisticsListing from '@/modules/transaction/components/TransactionStatisticsListing'

function TransactionStatisticsPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<TransactionStatisticsListing />
			</div>
		</PageContainer>
	)
}

const GuardedTransactionStatisticsPage = withUserPermission(
	TransactionStatisticsPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
	},
)

export default GuardedTransactionStatisticsPage
